import React from 'react';
import { motion } from 'framer-motion';
import { event, hero } from '../data/masterclass';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="relative isolate overflow-hidden bg-ink" data-id="element-55" data-mp="ei1zpycqqp3r">
      <img src={event.backdropUrl} alt="" aria-hidden="true" className="absolute inset-0 -z-10 h-full w-full object-cover opacity-70" data-id="element-56" data-mp="9lbfqzxtf9d2" />
      <div className="absolute inset-0 -z-10 bg-ink/65" aria-hidden="true" data-id="element-57" data-mp="128frdnreylxt" />

      <div className="mx-auto w-full max-w-7xl px-6 pb-20 pt-8 lg:px-10 lg:pb-28" data-id="element-58" data-mp="xanqw5cpdri0">
        <img src={event.logoUrl} alt="Meet the Eatmons" className="h-20 w-20 object-contain sm:h-24 sm:w-24" data-id="element-59" data-mp="sbb0xbqjc4b7" />

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: EASE
      }} className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-60" data-mp="nbeyvi1eemya">
          <h1 className="font-display text-5xl font-bold uppercase leading-[0.95] text-white sm:text-6xl lg:text-7xl" data-id="element-61" data-mp="3j8ixl0k6uiv8">
            Can your relationship carry the weight of your{' '}
            <span className="text-gold" data-id="element-62" data-mp="3o5j2371e3dk8">success?</span>
          </h1>

          <div className="mt-8 max-w-2xl space-y-4" data-id="element-63" data-mp="399jq3lb5st9t">
            {hero.support.map(line => <p key={line} className="text-lg leading-relaxed text-white/70" data-id="element-64" data-mp="3e84mf9naissz">
                {line}
              </p>)}
          </div>

          <p className="mt-12 border-y border-gold/25 px-8 py-5 text-sm font-semibold uppercase tracking-[0.14em] text-gold-pale" data-id="element-65" data-mp="358rg2pugqkch">
            {event.eventLine}
          </p>
        </motion.div>
      </div>
    </header>;
}